export default "__VITE_ASSET__CNCymWZ5__"